exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "app-footer footer.pageContent{position:static}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/common/footer/footer.styl
// module id = 625
// module chunks = 0